import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const footerStyle: React.CSSProperties = {
    background: 'linear-gradient(135deg, #6b46c1 0%, #9333ea 100%)',
    color: 'white',
    padding: '3rem 2rem 2rem'
  };

  const containerStyle: React.CSSProperties = {
    maxWidth: '1200px',
    margin: '0 auto'
  };

  const bottomStyle: React.CSSProperties = {
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    paddingTop: '2rem',
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.8)'
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        {/* Bottom */}
        <div style={bottomStyle}>
          <p>{t('footerText')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 